import type { DeviceShadowData } from "@screencloud/native-players-helpers";

/**
 * GraphQL ScreenDeviceStateData lags DeviceShadowData. Key presence (not value
 * types) is enough to treat the payload as the typed shadow shape.
 */
export function isDeviceShadowState(value: unknown): value is DeviceShadowData {
  return (
    typeof value === "object" &&
    value !== null &&
    "healthScore" in value &&
    "isOnline" in value &&
    "deviceId" in value &&
    "state" in value &&
    "metadata" in value &&
    "apiSchema" in value
  );
}
